import { initIDB } from "./";

/**
 * Clears all records from the specified object store(s) in IndexedDB.
 * Waits for transaction completion before resolving.
 *
 * @param storeNames - Array of object store names to clear (e.g. ["cache"])
 * @returns Promise that resolves with "success" when all stores have been cleared
 */
export const indexedDbDeleteAll = (storeNames: string[]): Promise<string> => {
  return new Promise((resolve, reject) => {
    initIDB()
      .then((db) => {
        const idb = db as IDBDatabase;
        const validStores = storeNames.filter(
          (name) => idb.objectStoreNames && idb.objectStoreNames.contains(name),
        );

        if (validStores.length === 0) {
          idb.close();
          resolve("success");
          return;
        }

        const txn = idb.transaction(validStores, "readwrite");

        txn.oncomplete = () => {
          idb.close();
          resolve("success");
        };

        txn.onerror = (event) => {
          idb.close();
          reject((event.target as any)?.error || event);
        };

        txn.onabort = (event) => {
          idb.close();
          reject((event.target as any)?.error || event);
        };

        validStores.forEach((storeName) => {
          const store = txn.objectStore(storeName);
          store.clear();
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};
